<template>
    <header id="header-container" style="position: relative;">
        <div class="top-banner" id="MBnr-0" v-if="showTopBanner" @mouseenter="stopTopBannerRotation"
            @mouseleave="startTopBannerRotation">
            <Transition name="top-banner-message">
                <span :key="topBannerMessageIndex" class="top-banner-message">
                    <span class="top-banner-message-content" :class="{
                        'is-promo': topBannerMessageIndex === 1,
                        'is-solution': topBannerMessageIndex === 2
                    }">
                        <span v-if="topBannerMessageIndex === 1" class="top-banner-kicker">NEW</span>
                        <template v-if="topBannerMessageIndex === 2">
                            <span>{{ t('top_banner.solution_prefix') }}</span>
                            <strong class="top-banner-highlight">{{ t('top_banner.solution_highlight') }}</strong>
                            <span>{{ t('top_banner.solution_suffix') }}</span>
                        </template>
                        <span v-else>{{ topBannerMessageIndex === 1 ? t('top_banner.promo_prefix') :
                            currentTopBannerMessage }}</span>
                        <strong v-if="topBannerMessageIndex === 1" class="top-banner-highlight">0%</strong>
                    </span>
                </span>
            </Transition>
            <button v-if="isLoggedIn" type="button" class="feedback-top-entry feedback-top-button"
                @click="openFeedbackDialog">
                <el-icon>
                    <Warning />
                </el-icon>
                <span>{{ t('feedback.entry_title') }}</span>
            </button>
            <div class="top-banner-close">
                <!-- <a href="javascript:" class="NotBnrOpen">
                    <i class="la la-times"></i>
                </a> -->
            </div>
        </div>
        <div id="header">
            <div id="logo">
                <a href="/">
                    <img src="/images/top_logo.png?2" alt="차이나원">
                </a>
            </div>
            <div class="navContainer-pc">
                <div class="nav-inner">
                    <div class="nav-item" v-for="menu in navList" :key="menu.key"
                        :class="{ 'route-active': activeTopMenuKey === menu.key }" @click="handleTopNavClick(menu)"
                        @mouseenter="handleHeaderNavEnter(menu.key, $event)" @mouseleave="handleNavLeave">
                        <img v-if="menu.key === 'rockets'" class="nav-item-icon" src="/images/rocket-btn.png" alt=""
                            aria-hidden="true">
                        {{ menu.label }}
                    </div>
                </div>
                <div ref="navDropdownRef" :class="['dropdown', {
                    'personal-dropdown': activeMenuPc === 'mypage' || isServiceCenterMenu,
                    'guide-dropdown': activeMenuPc === 'bbs_22',
                    'service-card-dropdown': activeMenuPc === 'purchase' || activeMenuPc === 'lcl',
                    'lcl-dropdown': activeMenuPc === 'lcl',
                    'three-pl-dropdown': activeMenuPc === '3PL' || activeMenuPc === 'rockets'
                }]" v-if="activeMenuPc" :style="activeMenuPc === 'bbs_22'
                    ? guideMenuPosition
                    : activeMenuPc === '3PL'
                        ? threePlMenuPosition
                        : activeMenuPc === 'rockets'
                            ? rocketMenuPosition
                            : activeMenuPc === 'purchase' || activeMenuPc === 'lcl'
                                ? serviceMenuPosition
                                : undefined" @mouseenter="handleDropdownEnter" @mouseleave="handleDropdownLeave">
                    <!-- 个人中心一次性展示所有分组和入口。 -->
                    <div v-if="activeMenuPc === 'bbs_22'" class="dropdown-box guide-menu-box">
                        <button v-for="(item, index) in guideMenuItems" :key="item.key || item.path || item.label"
                            type="button" class="guide-menu-item" @click="handleMenuClick(item)">
                            <span class="guide-menu-number" aria-hidden="true">{{ String(index + 1).padStart(2, '0')
                                }}</span>
                            <span class="guide-menu-label">{{ item.label }}</span>
                            <span class="guide-menu-arrow" aria-hidden="true">&rsaquo;</span>
                        </button>
                    </div>
                    <div v-else-if="activeMenuPc === 'mypage' || isServiceCenterMenu"
                        class="dropdown-box personal-menu-box" :class="{
                            'is-mypage': activeMenuPc === 'mypage',
                            'is-service-center': isServiceCenterMenu
                        }" :style="activeMenuPc === 'mypage' ? personalMenuPosition : serviceCenterMenuPosition">
                        <div v-for="group in currentMenuChildren" :key="group.key" class="personal-menu-group">
                            <button v-if="group.path" type="button" class="third-title third-title-link"
                                @click="handleMenuClick(group)">
                                <span>{{ group.label }}</span>
                                <span aria-hidden="true">›</span>
                            </button>
                            <div v-else class="third-title">{{ group.label }}</div>
                            <div class="personal-group-items">
                                <div v-for="item in group.children" :key="item.path || item.label" class="third-item"
                                    :class="{
                                        'has-icon': activeMenuPc === 'mypage',
                                        'is-compensation': item.iconStyle === 'compensation',
                                        'is-pay': item.iconStyle === 'pay'
                                    }" @click="handleMenuClick(item)">
                                    <el-icon v-if="activeMenuPc === 'mypage'" class="personal-menu-icon">
                                        <svg v-if="item.iconStyle === 'compensation'" viewBox="0 0 24 24"
                                            aria-hidden="true">
                                            <path fill="currentColor"
                                                d="M13.5 2.2c.4 3.1-1.3 4.5-2.8 6.1-1.1 1.2-2.1 2.4-1.8 4.2.1.7.5 1.3 1.1 1.8-.1-1.8.8-3.2 2.1-4.5.2 2.2 1.6 3.3 2.7 4.5.8.9 1.3 1.8 1.2 3.1 1.2-1 2-2.5 2-4.2 0-2.9-1.6-5.5-4.5-11zM8.4 9.1C5.5 11.5 4 14 4 16.5A7.5 7.5 0 0 0 11.5 24a7.5 7.5 0 0 0 7.5-7.5c0-.7-.1-1.4-.3-2-1 3.5-3 4.7-4.7 5.2.5-1.2.2-2.5-.8-3.6-.6-.7-1.3-1.3-1.8-2.1-.4 1.2-.3 2.3.2 3.4-2-.4-4.4-2.4-3.2-8.3z" />
                                        </svg>
                                        <component v-else :is="getPersonalMenuIcon(item.path)" />
                                    </el-icon>
                                    <span>{{ item.label }}</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- 电商快递和 LCL/FCL 使用统一的紧凑卡片式入口。 -->
                    <div v-else-if="activeMenuPc === 'purchase' || activeMenuPc === 'lcl'"
                        class="dropdown-box service-menu-box">
                        <section v-for="second in currentMenuChildren" :key="second.key" class="service-menu-section">
                            <div class="service-menu-card-list">
                                <article v-for="(section, sectionIndex) in getMenuSections(second.children)"
                                    :key="`${second.key}-${sectionIndex}`"
                                    :class="['service-menu-card', { 'is-single-link': getActionableMenuItems(section.items).length === 1 }]">
                                    <div :class="['service-menu-card-icon', { 'is-delivery': sectionIndex > 0 }]">
                                        <el-icon>
                                            <Van v-if="sectionIndex > 0" />
                                            <ShoppingBag v-else />
                                        </el-icon>
                                    </div>
                                    <div class="service-menu-card-content">
                                        <div class="service-menu-card-title">{{ section.title }}</div>
                                        <button v-for="item in getActionableMenuItems(section.items)"
                                            :key="item.path || item.label" type="button" class="service-menu-card-link"
                                            @click="handleMenuClick(item)"
                                            :aria-label="getActionableMenuItems(section.items).length === 1 ? item.label : undefined">
                                            <span>{{ item.label }}</span>
                                            <span class="service-menu-link-arrow">&rsaquo;</span>
                                        </button>
                                    </div>
                                </article>
                            </div>
                        </section>
                    </div>

                    <!-- 橙火入仓服务沿用 3PL 的分栏样式，栏目以国旗区分（非流程，不显示步骤号）。 -->
                    <div v-else-if="activeMenuPc === 'rockets'" class="dropdown-box three-pl-menu-box">
                        <section v-for="second in currentMenuChildren" :key="second.key"
                            :class="['three-pl-column', `three-pl-column--${second.key}`]">
                            <div class="three-pl-column-title">
                                <img class="three-pl-column-flag"
                                    :src="second.key === 'rocket_cn' ? '/images/CN_flag.png' : '/images/flag_kr.png'"
                                    alt="" />
                                <div class="three-pl-column-text">
                                    <strong>{{ second.label }}</strong>
                                </div>
                            </div>

                            <!-- 入口名称已包含 구매대행/배송대행，不再显示分组小标题 -->
                            <button v-for="item in getActionableMenuItems(second.children)"
                                :key="item.path || item.label" type="button" class="three-pl-card-link"
                                @click="handleMenuClick(item)">
                                <span class="three-pl-link-label">{{ item.label }}</span>
                            </button>
                        </section>
                    </div>

                    <!-- 3PL 按 中国入库、韩国入库、韩国出库 的步骤号展示，菜单数据、跳转和交互逻辑保持不变。 -->
                    <div v-else-if="activeMenuPc === '3PL'" class="dropdown-box three-pl-menu-box">
                        <template v-for="(second, stepIndex) in currentMenuChildren" :key="second.key">
                            <section :class="['three-pl-column', `three-pl-column--${second.key}`]">
                                <div class="three-pl-column-title">
                                    <span class="three-pl-step-no">{{ stepIndex + 1 }}</span>
                                    <div class="three-pl-column-text">
                                        <strong>{{ second.label }}</strong>
                                        <span v-if="second.desc" class="three-pl-column-desc">{{ second.desc }}</span>
                                    </div>
                                </div>

                                <div v-for="(section, sectionIndex) in getMenuSections(second.children)"
                                    :key="`${second.key}-${sectionIndex}`" class="three-pl-card">
                                    <div class="three-pl-card-title">{{ section.title }}</div>
                                    <button v-for="item in section.items" :key="item.path || item.label" type="button"
                                        class="three-pl-card-link" @click="handleMenuClick(item)">
                                        <span class="three-pl-link-label">{{ item.label }}</span>
                                        <span v-if="item.desc" class="three-pl-link-desc">{{ item.desc }}</span>
                                    </button>
                                </div>
                            </section>
                        </template>
                    </div>

                    <div v-else class="dropdown-box">
                        <div class="second-menu">
                            <div v-for="second in currentMenuChildren" :key="second.key"
                                :class="['second-item', { active: activeSecond === second.key }]"
                                @mouseenter="activeSecond = second.key">
                                <span class="second-label">{{ second.label }}</span>
                                <span class="second-arrow">&rsaquo;</span>
                            </div>
                        </div>
                        <div class="third-menu" v-if="currentThirdItems.length > 0">
                            <!-- 有标题的菜单 - 横向分组显示 -->
                            <div v-if="hasAnyTitle" class="third-group">
                                <template v-for="(third, index) in currentThirdItems" :key="index">
                                    <div v-if="third.type === 'title'" class="third-group-section">
                                        <div class="third-title">{{ third.label }}</div>
                                        <div class="third-group-items">
                                            <template v-for="(item, idx) in getItemsUnderTitle(index)" :key="idx">
                                                <div class="third-item" @click="handleMenuClick(item)">{{ item.label }}
                                                </div>
                                            </template>
                                        </div>
                                    </div>
                                </template>
                            </div>
                            <!-- 没有标题的菜单 - 竖向显示 -->
                            <div v-else class="third-group-vertical">
                                <div v-for="(third, index) in currentThirdItems" :key="index" class="third-item"
                                    @click="handleMenuClick(third)">
                                    {{ third.label }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div id="top_menu">
                <template v-if="!isLoggedIn">
                    <div class="trans-lang margin-right-10">
                        <el-select ref="languageSelectRef" @change="changeLanguage" v-model="selectedLanguage"
                            :disabled="langLoading" automatic-dropdown @mouseenter="openLanguageSelect"
                            @mouseleave="scheduleLanguageClose" @visible-change="handleLanguageVisibleChange"
                            class="language-select" popper-class="language-select-popper"
                            :aria-label="t('select.language_zh')">
                            <template #prefix>
                                <span class="language-trigger-icon" aria-hidden="true">
                                    <svg viewBox="0 0 24 24" fill="none">
                                        <circle cx="12" cy="12" r="8.5" />
                                        <path
                                            d="M3.8 9h16.4M3.8 15h16.4M12 3.5c2.1 2.3 3.2 5.1 3.2 8.5S14.1 18.2 12 20.5M12 3.5C9.9 5.8 8.8 8.6 8.8 12s1.1 6.2 3.2 8.5" />
                                    </svg>
                                </span>
                            </template>
                            <el-option value="zh-CN" :label="t('select.language_zh')">
                                <div class="language-option">
                                    <span>中文</span>
                                </div>
                            </el-option>
                            <el-option value="ko-KR" :label="t('select.language_kr')">
                                <div class="language-option">
                                    <span>한국어</span>
                                </div>
                            </el-option>
                        </el-select>
                    </div>
                    <div class="header-widget">
                        <div class="header-notifications user-menu">
                            <!--div class="header-notifications-trigger"-->
                            <div class="user-avatar-position">
                                <a href="/login" class="loginBtn">{{ t('login_button') }}</a>
                                <a href="/join" class="resBtn">{{ t('register_button') }}</a>
                            </div>
                        </div>
                    </div>
                </template>
                <template v-else>
                    <div class="userinformation">
                        <button type="button" class="warehouse-entry-button" :title="t('warehouse_popup.entry')"
                            @click="openWarehousePopup">
                            <el-icon>
                                <Location />
                            </el-icon>
                            <span>{{ t('warehouse_popup.entry') }}</span>
                        </button>

                        <el-badge :value="note_qt" :hidden="note_qt < 1" class="header-message-badge">
                            <button type="button" class="header-message-button" :title="t('header_user_menu.messages')"
                                @click="goToMessages">
                                <el-icon>
                                    <Bell />
                                </el-icon>
                            </button>
                        </el-badge>

                        <el-dropdown ref="userDropdownRef" trigger="hover" placement="bottom-end"
                            popper-class="header-user-dropdown" :hide-on-click="false" @command="handleUserCommand"
                            @visible-change="handleUserDropdownVisibleChange">
                            <button class="user-dropdown-trigger" type="button">
                                <span class="user-avatar">{{ userInitial }}</span>
                                <span class="user-name">{{ userName }}</span>
                                <el-icon class="user-arrow">
                                    <ArrowDown />
                                </el-icon>
                            </button>
                            <template #dropdown>
                                <el-dropdown-menu>
                                    <div class="balance-summary">
                                        <a href="/deposit-ko" class="balance-card korea-balance">
                                            <span class="balance-content">
                                                <span class="balance-label">{{ t('deposit_account.korea_balance')
                                                }}</span>
                                                <strong>{{ formatThousands(KOREA_DPST) }}</strong>
                                            </span>
                                        </a>
                                        <a href="/deposit-ko" class="balance-card china-balance">
                                            <span class="balance-content">
                                                <span class="balance-label">{{ t('deposit_account.china_balance')
                                                }}</span>
                                                <strong>{{ formatThousands(CHINA_DPST) }}</strong>
                                            </span>
                                        </a>
                                        <a v-if="showCompensationMenu" href="/compensation-deposit"
                                            class="balance-card compensation-balance">
                                            <span class="balance-content">
                                                <span class="balance-label">{{ t('COMPENSATION_DEPOSIT.short_title')
                                                }}</span>
                                                <strong>{{ formatThousands(COMPENSATION_DPST) }}</strong>
                                            </span>
                                        </a>
                                    </div>
                                    <div class="dropdown-order-stats">
                                        <button type="button" @click.stop="handleUserCommand('/pay')">
                                            <span>{{ t('info.unpay') }}</span>
                                            <strong>{{ unpaid }}</strong>
                                        </button>
                                        <button type="button" @click.stop="handleUserCommand('/nodata?categoryId=43')">
                                            <span>{{ t('info.nodata') }}</span>
                                            <strong>{{ NODATA }}</strong>
                                        </button>
                                    </div>
                                    <el-dropdown-item divided command="/my-page">
                                        <el-icon class="menu-icon">
                                            <User />
                                        </el-icon>
                                        <span>{{ t('header_user_menu.personal_center') }}</span>
                                    </el-dropdown-item>
                                    <el-dropdown-item command="/orders">
                                        <el-icon class="menu-icon">
                                            <Box />
                                        </el-icon>
                                        <span>{{ t('header_user_menu.my_orders') }}</span>
                                    </el-dropdown-item>
                                    <el-dropdown-item command="/pay">
                                        <el-icon class="menu-icon">
                                            <Document />
                                        </el-icon>
                                        <span>{{ t('header_user_menu.bill_management') }}</span>
                                    </el-dropdown-item>
                                    <el-dropdown-item command="/coupons">
                                        <el-icon class="menu-icon">
                                            <Discount />
                                        </el-icon>
                                        <span>{{ t('header_user_menu.coupon_management') }}</span>
                                        <strong class="menu-count">{{ couponCount }}</strong>
                                    </el-dropdown-item>
                                    <el-dropdown-item v-if="showCompensationMenu" command="/compensation-deposit">
                                        <el-icon class="menu-icon compensation-menu-icon">
                                            <CompensationFireIcon />
                                        </el-icon>
                                        <span>{{ t('header_user_menu.compensation_deposit_management') }}</span>
                                    </el-dropdown-item>
                                    <el-dropdown-item command="/deposit-ko?tab=DepositReq_3">
                                        <el-icon class="menu-icon">
                                            <CreditCard />
                                        </el-icon>
                                        <span>{{ t('header_user_menu.recharge_records') }}</span>
                                    </el-dropdown-item>
                                    <el-dropdown-item command="/api-settings">
                                        <el-icon class="menu-icon">
                                            <Setting />
                                        </el-icon>
                                        <span>{{ t('header_user_menu.api_settings') }}</span>
                                    </el-dropdown-item>
                                    <el-dropdown-item divided command="language-menu" class="language-menu-item"
                                        :class="{ 'is-expanded': languageOptionsVisible }">
                                        <el-icon class="menu-icon language-menu-icon">
                                            <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
                                                <circle cx="12" cy="12" r="8.5" />
                                                <path
                                                    d="M3.8 9h16.4M3.8 15h16.4M12 3.5c2.1 2.3 3.2 5.1 3.2 8.5S14.1 18.2 12 20.5M12 3.5C9.9 5.8 8.8 8.6 8.8 12s1.1 6.2 3.2 8.5" />
                                            </svg>
                                        </el-icon>
                                        <span>{{ t('header_user_menu.language_current', {
                                            language: currentLanguageLabel
                                        }) }}</span>
                                        <span class="language-menu-arrow" aria-hidden="true">›</span>
                                    </el-dropdown-item>
                                    <div v-show="languageOptionsVisible" class="language-options-panel" @click.stop>
                                        <button v-for="language in languageOptions" :key="language.value" type="button"
                                            class="language-option-button"
                                            :class="{ 'is-active': selectedLanguage === language.value }"
                                            @click.stop="selectUserLanguage(language.value)">
                                            <span>{{ language.label }}</span>
                                            <span v-if="selectedLanguage === language.value"
                                                class="language-option-check" aria-hidden="true">✓</span>
                                        </button>
                                    </div>
                                    <el-dropdown-item command="logout" class="logout-menu-item">
                                        <el-icon class="menu-icon">
                                            <SwitchButton />
                                        </el-icon>
                                        <span>{{ t('button.logout') }}</span>
                                    </el-dropdown-item>
                                </el-dropdown-menu>
                            </template>
                        </el-dropdown>
                    </div>
                </template>
            </div>

            <button v-show="!isMobileMenuOpen" type="button" class="mobile-language-button"
                :aria-label="isChineseLanguage ? '한국어' : '中文'" @click="toggleMobileLanguage">
                <span>{{ isChineseLanguage ? '中文' : '한국어' }}</span>
            </button>

            <button v-show="!isMobileMenuOpen || menuLevel === 1" type="button" class="menu-btn"
                :class="{ 'is-open': isMobileMenuOpen }" :aria-label="isMobileMenuOpen ? t('button.close') : 'Menu'"
                @click="toggleMobileMenu">
                <el-icon>
                    <Close v-if="isMobileMenuOpen" />
                    <Menu v-else />
                </el-icon>
            </button>

        </div>

        <!-- 面包屑：页面里的 PageTitle 通过 Teleport 渲染到 #header-breadcrumb -->
        <div class="header-crumb">
            <div class="header-crumb-inner">
                <RouterLink to="/" class="header-crumb-home">
                    <el-icon>
                        <HomeFilled />
                    </el-icon>
                    <span>{{ t('bbs.home') }}</span>
                </RouterLink>
                <span class="header-crumb-sep" aria-hidden="true">›</span>
                <div id="header-breadcrumb" class="header-crumb-slot"></div>
            </div>
        </div>

        <div class="navContainer" :class="{ open: isMobileMenuOpen }" v-if="isMobileMenuOpen">
            <div class="menu-panel main" :class="{ active: menuLevel === 1 }">
                <div class="mobile-user" :class="{ 'is-guest': !isLoggedIn }">
                    <!-- 未登录 -->
                    <template v-if="!isLoggedIn">
                        <div class="mobile-auth-brand">
                            <span class="mobile-brand-mark" aria-hidden="true">
                                <img src="/images/logo-list.png" alt="" />
                            </span>
                            <span class="mobile-brand-copy">
                                <strong>CHINA<span>ONE</span></strong>
                            </span>
                        </div>
                        <div class="auth-box">
                            <a href="/login" class="btn login">
                                {{ t('login_button') }}
                            </a>

                            <a href="/join" class="btn register">
                                {{ t('register_button') }}
                            </a>
                        </div>
                    </template>
                    <!-- 已登录 -->
                    <template v-else>
                        <div class="user-box">
                            <div class="user-top">
                                <div class="mobile-avatar">{{ userInitial }}</div>
                                <div class="user-info">
                                    <div class="name">{{ userName }}</div>
                                </div>
                                <button type="button" class="mobile-member-link"
                                    @click="handleMenuClick({ path: '/my-page' })">
                                    <el-icon>
                                        <User />
                                    </el-icon>
                                    <span>{{ t('menu.member_info') }}</span>
                                </button>
                            </div>
                            <div class="mobile-balance-summary">
                                <a href="/deposit-ko" class="mobile-balance-item is-korea">
                                    <span class="mobile-balance-icon">₩</span>
                                    <span class="mobile-balance-copy">
                                        <span>{{ t('deposit_account.korea_balance') }}</span>
                                        <strong>{{ formatThousands(KOREA_DPST) }}</strong>
                                    </span>
                                </a>
                                <a href="/deposit-ko" class="mobile-balance-item is-china">
                                    <span class="mobile-balance-icon">₩</span>
                                    <span class="mobile-balance-copy">
                                        <span>{{ t('deposit_account.china_balance') }}</span>
                                        <strong>{{ formatThousands(CHINA_DPST) }}</strong>
                                    </span>
                                </a>
                                <a v-if="showCompensationMenu" href="/compensation-deposit"
                                    class="mobile-balance-item is-compensation">
                                    <span class="mobile-balance-icon">
                                        <CompensationFireIcon />
                                    </span>
                                    <span class="mobile-balance-copy">
                                        <span>{{ t('COMPENSATION_DEPOSIT.short_title') }}</span>
                                        <strong>{{ formatThousands(COMPENSATION_DPST) }}</strong>
                                    </span>
                                    <span class="mobile-balance-arrow" aria-hidden="true">›</span>
                                </a>
                            </div>
                            <div class="user-cards">
                                <a href="/pay" class="card">
                                    <el-icon class="mobile-stat-icon">
                                        <Wallet />
                                    </el-icon>
                                    <div class="num">{{ unpaid }}</div>
                                    <div class="label">{{ t('info.unpay') }}</div>
                                </a>
                                <a href="/notes" class="card">
                                    <el-icon class="mobile-stat-icon">
                                        <Bell />
                                    </el-icon>
                                    <div class="num">{{ note_qt }}</div>
                                    <div class="label">{{ t('info.note') }}</div>
                                </a>
                                <a href="/nodata?categoryId=43" class="card">
                                    <el-icon class="mobile-stat-icon">
                                        <Box />
                                    </el-icon>
                                    <div class="num">{{ NODATA }}</div>
                                    <div class="label">{{ t('info.nodata') }}</div>
                                </a>
                            </div>
                        </div>
                    </template>
                </div>
                <div class="mobile-services-heading">
                    <strong>{{ t('header_user_menu.common_services') }}</strong>

                </div>
                <ul class="mobile-nav-list">
                    <li v-for="menu in navList" :key="menu.key"
                        :class="{ 'route-active': activeTopMenuKey === menu.key }"
                        @click="handleMobileTopNavClick(menu)">
                        <span class="mobile-nav-content">
                            <span class="mobile-nav-icon">
                                <el-icon>
                                    <component :is="getMobileMenuIcon(menu)" />
                                </el-icon>
                            </span>
                            <span>{{ menu.label }}</span>
                        </span>
                    </li>
                </ul>
                <button v-if="isLoggedIn" type="button" class="logout mobile-logout-bottom" @click="confirmLogout">
                    <el-icon>
                        <SwitchButton />
                    </el-icon>
                    <span>{{ t('button.logout') }}</span>
                </button>
            </div>
            <!-- 移动端一级菜单点击后直接展示全部最终入口 -->
            <div class="menu-panel sub" :class="{ active: menuLevel === 2 }">
                <div class="menu-header">
                    <span @click="backToMain">&larr; {{ t('button.back') }}</span>
                </div>

                <div v-if="currentMobileMenu" class="mobile-direct-menu">
                    <template v-for="(second, secondIndex) in currentMobileMenu.children"
                        :key="second.key || secondIndex">
                        <a v-if="second.path && !second.children?.length" href="javascript:;" class="mobile-third-link"
                            @click="handleMenuClick(second)">
                            {{ second.label }}
                        </a>

                        <section v-else-if="second.children?.length" class="mobile-menu-group">
                            <div class="mobile-second-title">{{ second.label }}</div>
                            <template v-for="(third, thirdIndex) in second.children" :key="third.key || thirdIndex">
                                <div v-if="third.type === 'title'" class="mobile-third-title">
                                    {{ third.label }}
                                </div>
                                <a v-else-if="third.path" href="javascript:;" class="mobile-third-link"
                                    :class="{ 'is-compensation': third.iconStyle === 'compensation' }"
                                    @click="handleMenuClick(third)">
                                    {{ third.label }}
                                </a>
                            </template>
                            <a v-if="currentMobileMenu.key === 'mypage' && second.key === 'acount'" href="javascript:;"
                                class="mobile-third-link" @click="handleMenuClick({ path: '/api-settings' })">
                                {{ t('header_user_menu.api_settings') }}
                            </a>
                        </section>
                    </template>
                </div>
            </div>
        </div>
        <div v-if="isMobileMenuOpen" class="mask" @click="toggleMobileMenu"></div>
        <FeedbackSubmitDialog ref="feedbackDialogRef" />
    </header>
</template>
<script setup>
import { useI18n } from 'vue-i18n'
const { t, locale } = useI18n()
import { ref, computed, watch, nextTick, onMounted, onBeforeUnmount } from 'vue'
import { formatThousands } from '@/utils/format';
import { fnPopWin } from '../utils/windowUtils'
import { useUserStore } from '@/stores/user'
import { useRoute, useRouter } from 'vue-router'
import { useNavMenu } from '@/composables/useNavMenu'
import { useNavigationStore } from '@/stores/navigationStore'
import { getSubmenuDestinations } from '@/utils/navigationMenu'
import { toast, showModal } from "@/composables/util";
import { loginService } from "@/services/user/auth";
import CompensationFireIcon from '@/components/icons/CompensationFireIcon.vue'
import FeedbackSubmitDialog from '@/components/FeedbackSubmitDialog.vue'
import { ArrowDown, Bell, User, Box, Document, OfficeBuilding, Van, ShoppingBag, Tickets, Discount, CreditCard, Setting, SwitchButton, Menu, Close, Goods, Wallet, DocumentChecked, Coin, Location, Connection, Warning, HomeFilled } from '@element-plus/icons-vue'
const userStore = useUserStore()
const router = useRouter()
const route = useRoute()
const navigationStore = useNavigationStore()
const userDropdownRef = ref(null)
const feedbackDialogRef = ref(null)

const openFeedbackDialog = () => feedbackDialogRef.value?.open()

const version = __APP_VERSION__;

const isLoggedIn = computed(() => !!userStore.userInfo)
const userName = computed(() => userStore.userInfo?.name || '')
const userInitial = computed(() => userName.value.trim().charAt(0).toUpperCase() || 'U')
// 从 userStore 获取用户数据
const KOREA_DPST = computed(() => userStore.koreaWallet?.amount || 0)
const CHINA_DPST = computed(() => userStore.chinaWallet?.amount || 0)
const COMPENSATION_DPST = computed(() => userStore.bonusAccountInfo?.availableAmount || 0)
const showCompensationMenu = computed(() => userStore.userInfo?.showCompensationMenu === 1)
const note_qt = computed(() => userStore.statisticsInfo?.siteMessageCount ?? 0)
const unpaid = computed(() => userStore.statisticsInfo?.unpaidOrderCount ?? 0)
const NODATA = computed(() => userStore.statisticsInfo?.nodataCount ?? 0)
const couponCount = computed(() => userStore.statisticsInfo?.couponCount ?? 0)
const openWarehousePopup = () => fnPopWin('/center-address', 650, 450)

watch(
    () => userStore.userInfo?.id,
    async (userId) => {
        if (!userId) return
        try {
            await userStore.fetchUserStatisticsInfo()
        } catch (error) {
            console.error('[Header] 获取用户统计信息失败:', error)
        }
    },
    { immediate: true }
)
const showTopBanner = ref(true)
const topBannerMessageIndex = ref(0)
const topBannerMessages = computed(() => [
    t('top_banner.msg'),
    t('top_banner.promo'),
    t('top_banner.solution')
])
const currentTopBannerMessage = computed(() => topBannerMessages.value[topBannerMessageIndex.value] || '')
let topBannerRotationTimer = null
const stopTopBannerRotation = () => {
    if (topBannerRotationTimer !== null) {
        window.clearInterval(topBannerRotationTimer)
        topBannerRotationTimer = null
    }
}
const startTopBannerRotation = () => {
    if (topBannerRotationTimer !== null || topBannerMessages.value.length < 2) return
    topBannerRotationTimer = window.setInterval(() => {
        topBannerMessageIndex.value = (topBannerMessageIndex.value + 1) % topBannerMessages.value.length
    }, 4000)
}
onMounted(startTopBannerRotation)
const personalMenuPosition = ref({})
const guideMenuPosition = ref({})
const serviceCenterMenuPosition = ref({})
const threePlMenuPosition = ref({})
const navDropdownRef = ref(null)
const threePlMenuWidth = ref(880)
const rocketMenuPosition = ref({})
const rocketMenuWidth = ref(560)
const serviceMenuPosition = ref({})
const {
    navList,
    activeMenuPc,
    activeSecond,
    currentMenuChildren,
    currentThirdItems,
    hasAnyTitle,
    handleNavEnter,
    handleNavLeave,
    handleDropdownEnter,
    handleDropdownLeave,
    closePcMenu,
    getItemsUnderTitle,
    isMobileMenuOpen,
    menuLevel,
    activeMenu,
    currentMobileMenu,
    toggleMobileMenu,
    openSubMenu,
    backToMain
} = useNavMenu()

const isServiceCenterNavItem = (menu) => {
    if (!menu) return false
    if (menu.label === t('menu.customer_service')) return true

    const childLabels = menu.children?.flatMap(group =>
        group.children?.map(item => item.label) || []
    ) || []

    // 动态分类的中韩文名称并非逐字对应，但服务中心下固定包含 3PL 公告。
    return childLabels.some(label => String(label || '').toUpperCase().includes('3PL'))
}

const isServiceCenterMenu = computed(() => {
    const activeMenuItem = navList.value.find(menu => menu.key === activeMenuPc.value)
    return isServiceCenterNavItem(activeMenuItem)
})

const isServiceGuideNavItem = (menu) => menu?.key === 'bbs_22'

const guideMenuItems = computed(() => {
    const items = []
    const collectItems = (menus = []) => {
        menus.forEach(item => {
            if (item.path) items.push(item)
            if (item.children?.length) collectItems(item.children)
        })
    }
    collectItems(currentMenuChildren.value)
    return items
})

const personalMenuIcons = {
    '/orders': Tickets,
    '/product-manage': Goods,
    '/product-manage-old': Goods,
    '/stock-manage': Box,
    '/pay': Wallet,
    '/pay?tab=paymentL': DocumentChecked,
    '/deposit-ko': CreditCard,
    '/my-page': User,
    '/coupons': Discount,
    '/point': Coin,
    '/receive-address': Location,
    '/cooperation': Connection,
}
const getPersonalMenuIcon = (path) => personalMenuIcons[path] || Tickets

const handleHeaderNavEnter = (menuKey, event) => {
    const currentTopMenu = navList.value.find(menu => menu.key === menuKey)
    handleNavEnter(menuKey)

    const rect = event?.currentTarget?.getBoundingClientRect?.()
    if (!rect) return

    if (isServiceGuideNavItem(currentTopMenu)) {
        const menuWidth = 260
        const viewportPadding = 12
        const centeredLeft = rect.left + rect.width / 2 - menuWidth / 2
        const left = Math.min(
            Math.max(centeredLeft, viewportPadding),
            window.innerWidth - menuWidth - viewportPadding
        )

        guideMenuPosition.value = {
            left: `${left}px`,
            top: `${rect.bottom + 8}px`
        }
        return
    }

    if (isServiceCenterNavItem(currentTopMenu)) {
        const menuWidth = 260
        const viewportPadding = 12
        const centeredLeft = rect.left + rect.width / 2 - menuWidth / 2
        const left = Math.min(
            Math.max(centeredLeft, viewportPadding),
            window.innerWidth - menuWidth - viewportPadding
        )

        serviceCenterMenuPosition.value = {
            left: `${left}px`,
            top: `${rect.bottom + 8}px`
        }
        return
    }

    if (menuKey === 'purchase' || menuKey === 'lcl') {
        const viewportPadding = 24
        const menuMaxWidth = menuKey === 'lcl' ? 500 : 640
        const menuWidth = Math.min(menuMaxWidth, window.innerWidth - viewportPadding * 2)
        const centeredLeft = rect.left + rect.width / 2 - menuWidth / 2
        const left = Math.min(
            Math.max(centeredLeft, viewportPadding),
            window.innerWidth - menuWidth - viewportPadding
        )

        serviceMenuPosition.value = {
            left: `${left}px`,
            top: `${rect.bottom + 8}px`,
            transform: 'none'
        }
        return
    }

    if (menuKey === '3PL' || menuKey === 'rockets') {
        const viewportPadding = 24
        const positionRef = menuKey === '3PL' ? threePlMenuPosition : rocketMenuPosition
        const widthRef = menuKey === '3PL' ? threePlMenuWidth : rocketMenuWidth
        const applyPosition = (menuWidth) => {
            const centeredLeft = rect.left + rect.width / 2 - menuWidth / 2
            const left = Math.min(
                Math.max(centeredLeft, viewportPadding),
                window.innerWidth - menuWidth - viewportPadding
            )

            positionRef.value = {
                left: `${left}px`,
                top: `${rect.bottom + 8}px`,
                transform: 'none'
            }
        }

        // 菜单宽度随内容收缩：先用上次实测宽度同步定位，渲染完成后按实际宽度校准到导航项居中
        applyPosition(widthRef.value)
        nextTick(() => {
            const measuredWidth = navDropdownRef.value?.offsetWidth
            if (!measuredWidth) return
            widthRef.value = measuredWidth
            applyPosition(measuredWidth)
        })
        return
    }

    if (menuKey !== 'mypage') return

    const menuWidth = 250
    const viewportPadding = 12
    const centeredLeft = rect.left + rect.width / 2 - menuWidth / 2
    const left = Math.min(
        Math.max(centeredLeft, viewportPadding),
        window.innerWidth - menuWidth - viewportPadding
    )

    personalMenuPosition.value = {
        left: `${left}px`,
        top: `${rect.bottom + 8}px`
    }
}

const getMenuSections = (items = []) => {
    const sections = []
    let currentSection = null

    items.forEach(item => {
        if (item.type === 'title') {
            currentSection = { title: item.label, items: [] }
            sections.push(currentSection)
            return
        }

        if (currentSection) currentSection.items.push(item)
    })

    return sections
}

const getActionableMenuItems = (items = []) => items.filter(item => item?.path)

const getMobileMenuIcon = (menu) => {
    const key = String(menu?.key || '')
    if (key === 'purchase') return ShoppingBag
    if (key === 'lcl') return Van
    if (key === 'rockets') return Box
    if (key === '3PL') return OfficeBuilding
    if (key === 'mypage') return User
    if (key === 'bbs_22') return DocumentChecked
    if (key.startsWith('bbs_')) return Bell
    return Goods
}

const handleTopNavClick = (menu) => {
    const firstChild = getSubmenuDestinations(menu?.children)[0]
    if (firstChild) handleMenuClick(firstChild)
    else if (menu?.path) handleMenuClick(menu)
}

const handleMobileTopNavClick = (menu) => {
    const children = menu?.children || []
    if (children.length) {
        // 只有二级、没有三级的菜单（如使用指南）：点击直达第一个链接，
        // 其余入口可在目标页面包屑导航里切换，无需再展开二级面板
        const hasThirdLevel = children.some(child => (child.children || []).length > 0)
        if (!hasThirdLevel) {
            handleTopNavClick(menu)
            return
        }
        openSubMenu(menu.key)
        return
    }
    if (menu?.path) handleMenuClick(menu)
}

const normalizeQuery = (query) => Object.fromEntries(
    Object.entries(query).map(([key, value]) => [key.toLowerCase(), String(value ?? '')])
)

const findRouteMenuMatch = () => {
    const targetPath = route.path === '/delivery-application'
        ? '/delivery-precautions'
        : route.path
    const currentQuery = normalizeQuery(route.query)

    if (route.path === '/delivery-application') {
        currentQuery.type = currentQuery.type === '2' ? 'buy' : currentQuery.type === '1' ? 'delivery' : currentQuery.type
        // 下单页使用 reqgroup，导航菜单使用 requestGroup，统一后才能延续上一步面包屑。
        currentQuery.requestgroup = currentQuery.requestgroup || currentQuery.reqgroup
    }

    let bestMatch = null
    let bestScore = -1
    const considerItem = (first, second, item) => {
        if (!item.path) return
        const resolved = router.resolve(item.path)
        if (resolved.path !== targetPath) return

        const itemQuery = normalizeQuery(resolved.query)
        delete itemQuery.title
        const entries = Object.entries(itemQuery)
        if (!entries.every(([key, value]) => currentQuery[key] === value)) return

        if (entries.length > bestScore) {
            bestScore = entries.length
            bestMatch = { first, second, item }
        }
    }

    navList.value.forEach(first => {
        const visit = (items, parent = null) => {
            items.forEach(item => {
                considerItem(first, parent, item)
                visit(item.children || [], item)
            })
        }
        visit(first.children || [])
        considerItem(first, null, first)
    })

    return bestMatch
}

const routeMenuMatch = computed(findRouteMenuMatch)
const activeTopMenuKey = computed(() => route.path === '/guide' || route.path.startsWith('/guide/')
    ? 'bbs_22'
    : routeMenuMatch.value?.first?.key || null)

const updateBreadcrumb = () => {
    const match = routeMenuMatch.value
    if (match) {
        navigationStore.setBreadcrumb(
            route.path,
            [match.first.label, match.second?.label, match.item === match.first ? null : match.item.label].filter(Boolean),
            getSubmenuDestinations(match.first.children)
        )
    } else {
        navigationStore.clearBreadcrumb(route.path)
    }
}

watch([() => route.fullPath, navList], updateBreadcrumb, { immediate: true, deep: true })



const langLoading = ref(false);
const languageSelectRef = ref(null)
const languageMenuVisible = ref(false)
let languageCloseTimer = null
let languagePopperElement = null

const clearLanguageCloseTimer = () => {
    if (!languageCloseTimer) return
    clearTimeout(languageCloseTimer)
    languageCloseTimer = null
}

const closeLanguageSelect = () => {
    clearLanguageCloseTimer()
    if (languageMenuVisible.value) languageSelectRef.value?.blur?.()
}

const scheduleLanguageClose = () => {
    clearLanguageCloseTimer()
    languageCloseTimer = setTimeout(closeLanguageSelect, 160)
}

const removeLanguagePopperListeners = () => {
    if (!languagePopperElement) return
    languagePopperElement.removeEventListener('mouseenter', clearLanguageCloseTimer)
    languagePopperElement.removeEventListener('mouseleave', scheduleLanguageClose)
    languagePopperElement = null
}

const handleLanguageVisibleChange = (visible) => {
    languageMenuVisible.value = visible
    if (!visible) {
        clearLanguageCloseTimer()
        removeLanguagePopperListeners()
        return
    }

    nextTick(() => {
        removeLanguagePopperListeners()
        const poppers = Array.from(document.querySelectorAll('.language-select-popper'))
        languagePopperElement = poppers.find(element => element.offsetParent !== null) || poppers.at(-1) || null
        languagePopperElement?.addEventListener('mouseenter', clearLanguageCloseTimer)
        languagePopperElement?.addEventListener('mouseleave', scheduleLanguageClose)
    })
}

const openLanguageSelect = () => {
    clearLanguageCloseTimer()
    if (!langLoading.value) {
        if (!languageMenuVisible.value) languageSelectRef.value?.toggleMenu()
    }
}
const selectedLanguage = computed({
    get: () => locale.value || 'ko-KR',
    set: (value) => {
        userStore.setLanguage(value)
        locale.value = value
    }
})


const changeLanguage = () => {
    window.location.reload()
}
const isChineseLanguage = computed(() => String(selectedLanguage.value).toLowerCase().startsWith('zh'))
const currentLanguageLabel = computed(() => isChineseLanguage.value ? '中文' : '한국어')
const languageOptionsVisible = ref(false)
const languageOptions = [
    { value: 'zh-CN', label: '中文' },
    { value: 'ko-KR', label: '한국어' },
]
const handleUserDropdownVisibleChange = (visible) => {
    if (!visible) languageOptionsVisible.value = false
}
const selectUserLanguage = (language) => {
    if (selectedLanguage.value === language) {
        languageOptionsVisible.value = false
        return
    }
    selectedLanguage.value = language
    changeLanguage()
}
const toggleMobileLanguage = () => {
    selectedLanguage.value = isChineseLanguage.value ? 'ko-KR' : 'zh-CN'
    changeLanguage()
}

onBeforeUnmount(() => {
    stopTopBannerRotation()
    clearLanguageCloseTimer()
    removeLanguagePopperListeners()
})
const isActive = (path) => {
    return window.location.pathname === path
}

// 处理菜单点击
const handleMenuClick = async (item) => {
    if (!item.path) return

    closePcMenu()
    if (isMobileMenuOpen.value) toggleMobileMenu()
    const destination = !userStore.userInfo?.token && !router.resolve(item.path).meta.public
        ? '/login'
        : item.path
    try {
        await router.push(destination)
    } catch (error) {
        console.error('[Header] 导航跳转失败，使用整页跳转兜底:', error)
        window.location.assign(destination)
    }
}

const handleLogout = async () => {
    try {
        const userId = userStore.userInfo?.id;
        if (userId) {
            const res = await loginService.logout(userId);
            toast(res.message || '退出成功', 'success');
        }
    } catch (error) {
        console.error('退出登录接口失败:', error);
    } finally {
        userStore.cleanUserInfo()
        localStorage.removeItem('user')
        localStorage.removeItem('token')
        router.replace('/login')
    }
}

const confirmLogout = async () => {
    try {
        await showModal(
            t('header_user_menu.logout_confirm'),
            'warning',
            t('header_user_menu.logout_title')
        )
        await handleLogout()
    } catch {
        // 用户取消退出
    }
}

const goToMessages = async () => {
    await router.push('/notes')
}

const handleUserCommand = async (command) => {
    if (command === 'logout') {
        await confirmLogout()
        return
    }
    if (command === 'language-menu') {
        languageOptionsVisible.value = !languageOptionsVisible.value
        return
    }
    await router.push(command)
    userDropdownRef.value?.handleClose?.()
}
</script>

<style scoped>
@import '@/assets/styles/header.css';

.nav-item {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    font-size: 16px;
    /* 只让文字附近触发下拉，上下不再留大块热区 */
    padding: 6px 10px;
}

/* 文字与下拉之间的连接桥：只在已悬停时生效，避免从下方空白处误触发 */
.nav-item::after {
    bottom: -12px;
    height: 12px;
    pointer-events: none;
}

.nav-item:hover::after {
    pointer-events: auto;
}

.nav-item-icon {
    width: auto;
    height: 22px;
}

.nav-item.route-active {
    border-radius: 6px 6px 0 0;
    color: #df2f35;
}

.nav-item.route-active::before {
    left: 12px;
    width: calc(100% - 24px);
    background: #ef4b50;
}

.menu-panel.main li.route-active {
    border-color: #f2cfd2;
    background: #fff7f7;
    color: #d92f35;
    font-weight: 700;
}

.menu-panel.main li.route-active::after {
    color: #d92f35;
}

.menu-panel.main li.route-active .mobile-nav-icon {
    background: #fff0f1;
    color: #e94048;
}

.language-select {
    width: 36px;
}

.mobile-language-button {
    display: none;
}

.language-trigger-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    color: #667085;
}

.language-trigger-icon svg {
    width: 20px;
    height: 20px;
    stroke: currentColor;
    stroke-width: 1.6;
    stroke-linecap: round;
    stroke-linejoin: round;
}

.language-option {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 9px;
    width: 100%;
    height: 100%;
}

:deep(.language-select .el-select__wrapper) {
    position: relative;
    display: flex;
    justify-content: center;
    min-height: 36px;
    padding: 4px 6px;
    border: 0;
    border-radius: 50%;
    background: #fbfbfb;
    box-shadow: none !important;
}

:deep(.language-select .el-select__wrapper:hover) {
    background: #edf1f5;
    box-shadow: none !important;
}

:deep(.language-select .el-select__prefix) {
    position: absolute;
    top: 50%;
    left: 50%;
    margin-right: 0;
    transform: translate(-50%, -50%);
}

:deep(.language-select .el-select__selected-item) {
    width: 0;
    min-width: 0;
    overflow: hidden;
    visibility: hidden;
}

:deep(.language-select .el-select__suffix) {
    display: none;
}

:global(.language-select-popper .el-select-dropdown__item) {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    height: 36px;
    padding: 0 8px;
    line-height: 36px;
}

:global(.language-select-popper) {
    min-width: 108px !important;
}

:global(.language-select-popper .el-popper__arrow) {
    display: none;
}

.compact-language {
    display: inline-flex;
    align-items: center;
    order: -1;
    margin-right: 8px;
    margin-left: 1px;
}

.warehouse-entry-button {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    order: -1;
    height: 36px;
    margin-right: 22px;
    padding: 0 9px;
    border: 0;
    border-radius: 7px;
    background: transparent;
    color: #596273;
    font-size: 14px !important;
    font-weight: 600;
    white-space: nowrap;
    cursor: pointer;
}

.warehouse-entry-button:hover {
    background: #fbfbfb;
    color: #ef4b50;
}

.warehouse-entry-button .el-icon {
    color: #8a93a3;
    font-size: 20px;
}

.userinformation {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-top: 23px;
}

.userinformation .trans-lang {
    margin-top: 0;
}

.balance-summary {
    display: flex;
    flex-direction: column;
    margin: 6px 12px 0;
    border: 1px solid #e5e7eb;
    border-radius: 6px;
    overflow: hidden;
    white-space: nowrap;
}

.balance-card {
    display: flex;
    align-items: center;
    min-width: 0;
    min-height: 34px;
    padding: 0 10px;
    background: #fff;
    color: #555;
    text-decoration: none;
}

.balance-card + .balance-card {
    border-top: 1px solid #e5e7eb;
}

.balance-card:hover {
    background: #fff5f5;
}

.balance-card:hover strong {
    color: #e94d4d;
}

.balance-currency {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 27px;
    height: 27px;
    flex: 0 0 27px;
    border-radius: 50%;
    font-family: "Arial Unicode MS", "Segoe UI Symbol", Arial, sans-serif;
    font-size: 16px;
    font-weight: 500;
    font-style: normal;
    line-height: 1;
    letter-spacing: 0;
    -webkit-font-smoothing: antialiased;
}

.korea-balance .balance-currency {
    background: #edf3ff;
    color: #367ee8;
}

.china-balance .balance-currency {
    background: #fff3e6;
    color: #ed8a19;
}

.compensation-balance .balance-currency {
    background: #fff0f1;
    color: #ff3038;
}

.balance-content {
    display: flex;
    flex: 1;
    min-width: 0;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
}

.balance-label {
    color: #7a808a;
    font-size: 12px;
}

.balance-summary strong {
    color: #303133;
    font-size: 13px;
    font-variant-numeric: tabular-nums;
}

.header-message-badge {
    display: inline-flex;
}

.header-message-button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 34px;
    height: 34px;
    padding: 0;
    border: 0;
    border-radius: 50%;
    background: transparent;
    color: #f5a623;
    cursor: pointer;
}

.header-message-button:hover {
    background: #fff7e8;
}

.header-message-button .el-icon {
    font-size: 21px;
}

:deep(.header-message-badge .el-badge__content) {
    top: 2px;
    right: 4px;
    border-width: 1px;
    transform: translate(55%, -45%);
}

.user-dropdown-trigger {
    display: inline-flex;
    align-items: center;
    gap: 7px;
    height: 36px;
    padding: 0 10px 0 5px;
    border: 0;
    border-radius: 18px;
    background: transparent;
    color: #303133;
    cursor: pointer;
}

.user-dropdown-trigger:hover {
    background: #fbfbfb;
}

.user-avatar {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    background: #4c6ef5;
    color: #fff;
    font-size: 13px;
    font-weight: 700;
}

.user-name {
    max-width: 120px;
    overflow: hidden;
    color: #333;
    font-size: 13px;
    font-weight: 600;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.user-arrow {
    color: #909399;
    font-size: 12px;
}

:global(.header-user-dropdown) {
    width: 220px;
    min-width: 220px;
    padding: 0 !important;
    overflow: hidden;
    border: 0 !important;
    border-radius: 8px !important;
    box-shadow: 0 8px 24px rgba(31, 41, 55, .16) !important;
}

:global(.header-user-dropdown .el-dropdown-menu) {
    width: 100%;
    padding: 4px 0;
    box-sizing: border-box;
}

:global(.header-user-dropdown .dropdown-order-stats) {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    margin: 6px 12px 8px;
    border: 1px solid #e5e7eb;
    border-radius: 6px;
    background: #fafafa;
}

:global(.header-user-dropdown .dropdown-order-stats button) {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 3px;
    min-width: 0;
    padding: 4px 8px;
    border: 0;
    background: transparent;
    color: #4b5563;
    font-size: 12px;
    cursor: pointer;
}

:global(.header-user-dropdown .dropdown-order-stats button + button) {
    border-left: 1px solid #e5e7eb;
}

:global(.header-user-dropdown .dropdown-order-stats button:hover) {
    background: #fff5f5;
    color: #e94d4d;
}

:global(.header-user-dropdown .dropdown-order-stats strong) {
    color: #303133;
    font-size: 15px;
}

:global(.header-user-dropdown .el-dropdown-menu__item) {
    display: flex;
    gap: 9px;
    min-height: 36px;
    padding: 0 18px;
    color: #4b5563;
    font-size: 13px;
}

:global(.header-user-dropdown .menu-icon) {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 18px;
    margin-right: 0;
    color: #9299a6;
    font-size: 15px;
    margin-top: -3px;
}

:global(.header-user-dropdown .el-dropdown-menu__item:hover .menu-icon),
:global(.header-user-dropdown .language-menu-item.is-expanded .menu-icon) {
    color: #e94d4d;
}

:global(.header-user-dropdown .compensation-menu-icon) {
    font-size: 16px;
    color: #e94d4d;
    margin-top: -4px;
}



:global(.header-user-dropdown .language-menu-icon svg) {
    width: 1em;
    height: 1em;
    stroke: currentColor;
    stroke-width: 1.6;
    stroke-linecap: round;
    stroke-linejoin: round;
}

:global(.header-user-dropdown .language-menu-item.is-expanded) {
    color: #e94d4d;
    background: #fff5f5;
}

:global(.header-user-dropdown .language-menu-arrow) {
    margin-left: auto;
    color: #9ca3af;
    font-size: 20px;
    line-height: 1;
    transition: transform .2s ease;
}

:global(.header-user-dropdown .language-menu-item.is-expanded .language-menu-arrow) {
    transform: rotate(90deg);
}

:global(.header-user-dropdown .language-options-panel) {
    margin: 6px 6px;
    padding: 4px;
    border: 1px solid #ebeef5;
    border-radius: 6px;
    background: #fafafa;
}

:global(.header-user-dropdown .language-option-button) {
    display: flex;
    align-items: center;
    gap: 9px;
    width: 100%;
    min-height: 34px;
    padding: 0 10px;
    border: 0;
    border-radius: 4px;
    background: transparent;
    color: #4b5563;
    font-size: 13px;
    text-align: left;
    cursor: pointer;
}

:global(.header-user-dropdown .language-option-button:hover) {
    color: #e94d4d;
    background: #fff;
}

:global(.header-user-dropdown .language-option-button.is-active) {
    color: #e94d4d;
    font-weight: 600;
}

:global(.header-user-dropdown .language-option-check) {
    margin-left: auto;
    color: #e94d4d;
    font-size: 14px;
}

.personal-menu-box {
    position: fixed;
    z-index: 101;
    display: flex;
    flex-direction: column;
    gap: 4px;
    width: 240px;
    min-height: 0;
    max-height: calc(100vh - 110px);
    padding: 8px 12px 10px;
    overflow-y: auto;
    border: 1px solid #edf0f3;
    border-radius: 10px;
    background: #fff;
    box-shadow: 0 8px 24px rgba(31, 45, 61, .14);
}

.personal-menu-box.is-mypage {
    gap: 6px;
    width: 250px;
    padding: 10px 14px 12px;
}

.personal-menu-box.is-service-center {
    gap: 8px;
    width: 260px;
    padding: 12px 16px 14px;
}

.personal-menu-box.is-service-center .personal-menu-group .third-title {
    margin-bottom: 4px;
    padding-bottom: 6px;
}

.personal-menu-box.is-service-center .personal-group-items {
    gap: 2px;
    padding: 3px 0 0 8px;
}

.personal-menu-box.is-service-center .personal-group-items .third-item {
    padding: 4px 8px;
    line-height: 22px;
}

.personal-menu-box.is-mypage .personal-menu-group .third-title {
    margin-bottom: 3px;
    padding-bottom: 5px;
}

.personal-menu-box.is-mypage .personal-group-items {
    gap: 1px;
    padding-top: 2px;
}

.personal-menu-box.is-mypage .personal-group-items .third-item {
    padding: 3px 8px;
    line-height: 21px;
}

.personal-dropdown {
    background: transparent;
    box-shadow: none;
    border-radius: 0;
    overflow: visible;
}

.guide-dropdown {
    width: 264px;
    overflow: visible;
    border: 1px solid #edf0f3;
    border-radius: 10px;
    background: #fff;
    box-shadow: 0 8px 24px rgba(31, 45, 61, .14);
}

.guide-menu-box {
    display: flex;
    max-height: calc(100vh - 130px);
    padding: 4px;
    flex-direction: column;
    overflow-y: auto;
}

.guide-menu-item {
    display: grid;
    width: 100%;
    min-height: 32px;
    padding: 4px 8px;
    grid-template-columns: 26px minmax(0, 1fr) 10px;
    align-items: center;
    gap: 7px;
    border: 0;
    border-radius: 6px;
    background: transparent;
    color: #30343b;
    cursor: pointer;
    font-size: 14px !important;
    text-align: left;
    transition: color .15s ease, background-color .15s ease;
}

.guide-menu-item:hover {
    background: #fff1f1;
    color: #e94d52;
}

.guide-menu-number {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 20px;
    border: 1px solid #dfe3e8;
    border-radius: 4px;
    background: #eceff2;
    color: #68717d;
    font-size: 10px;
    font-weight: 700;
    line-height: 20px;
    font-variant-numeric: tabular-nums;
    letter-spacing: .02em;
    transition: color .15s ease, background-color .15s ease;
}

.guide-menu-item:hover .guide-menu-number {
    border-color: #f0bfc2;
    background: #f9dfe1;
    color: #cf4047;
}

.guide-menu-label {
    display: flex;
    align-items: center;
    min-height: 20px;
    overflow: visible;
    line-height: 20px;
    overflow-wrap: anywhere;
    text-overflow: clip;
    white-space: normal;
}

.guide-menu-arrow {
    align-self: center;
    color: #b3bac5;
    font-size: 14px;
    line-height: 20px;
    text-align: right;
}

.personal-menu-group {
    min-width: 0;
}

.personal-menu-group .third-title {
    margin: 0 0 2px;
    padding: 0 0 4px;
    border-bottom: 1px solid #d7dbe2;
    color: #20232a;
    font-size: 16px;
    font-weight: 700;
    line-height: 22px;
}

.personal-menu-group .third-title-link {
    appearance: none;
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: space-between;
    border-top: 0;
    border-right: 0;
    border-left: 0;
    background: transparent;
    cursor: pointer;
    font-size: 16px !important;
    font-weight: 700 !important;
    line-height: 22px !important;
    text-align: left;
    transition: color .15s ease;
}

.personal-menu-group .third-title-link>span:first-child {
    font: inherit !important;
}

.personal-menu-group .third-title-link:hover {
    color: #ef4b50;
}

.mobile-second-link {
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: space-between;
    border-top: 0;
    border-right: 0;
    border-left: 0;
    cursor: pointer;
    font-family: inherit;
    text-align: left;
}

.personal-group-items {
    display: flex;
    flex-direction: column;
    gap: 0;
    padding: 1px 0 0 6px;
}

.personal-group-items .third-item {
    padding: 2px 6px;
    border-radius: 5px;
    color: #3c4048;
    font-size: 14px;
    line-height: 21px;
    transition: color .15s ease, background-color .15s ease;
}

.personal-group-items .third-item.has-icon {
    display: grid;
    grid-template-columns: 16px minmax(0, 1fr);
    align-items: center;
    gap: 9px;
}


.personal-group-items .third-item.has-icon>span {
    display: block;
    line-height: 24px;
}



.personal-menu-icon {
    width: 16px;
    height: 16px;
    color: #9299a6;
    font-size: 15px;
    line-height: 16px;
    transform: translateY(1px);
    transition: color .15s ease;
}

.personal-menu-icon :deep(svg) {
    display: block;
}


/* 只给赔偿火焰添加红底白色样式 */
.personal-group-items .third-item.is-compensation .personal-menu-icon {
    background: #ff3038;
    color: #fff;
    border-radius: 4px;
    transform: translateY(-1px);
}

.personal-group-items .third-item.is-compensation .personal-menu-icon :deep(svg) {
    color: #fff;
    width: 12px;
    height: 12px;
}

/* 账单结算：红底白色钱包图标，尺寸与赔偿火焰图标统一 */

.personal-group-items .third-item.is-pay .personal-menu-icon {
    background: #ff3038;
    color: #fff;
    border-radius: 4px;
    transform: translateY(-1px);
}

.personal-group-items .third-item.is-pay .personal-menu-icon :deep(svg) {
    color: #fff;
    width: 12px;
    height: 12px;
}

.personal-group-items .third-item:hover {
    color: #f04444;
    background: #fff5f5;
}

.personal-group-items .third-item:hover .personal-menu-icon {
    color: #d76060;
}

:global(.header-user-dropdown .el-dropdown-menu__item:hover) {
    color: #e94d4d;
    background: #fff5f5;
}

:global(.header-user-dropdown .menu-dot) {
    width: 7px;
    height: 7px;
    border-radius: 50%;
}

:global(.header-user-dropdown .nodata-dot) {
    background: #f59e0b;
}

:global(.header-user-dropdown .unpaid-dot) {
    background: #ef4444;
}

:global(.header-user-dropdown .note-dot) {
    background: #3b82f6;
}

:global(.header-user-dropdown .menu-count) {
    margin-left: auto;
    color: #303133;
}

:global(.header-user-dropdown .logout-menu-item) {
    color: #e94d4d;
}

:global(.header-user-dropdown .logout-menu-item .menu-icon) {

    color: #e94d4d;
}

/* Match the centered content container below the desktop navigation. */
@media (min-width: 1401px) {
    #header {
        display: flex;
        align-items: center;
        gap: 24px;
        max-width: var(--app-content-width);
        margin: 0 auto;
        padding: 0 12px;
    }

    #logo {
        position: static;
        display: flex;
        align-items: center;
        flex: 0 0 auto;
        margin: 0;
    }

    #logo img {
        position: static;
        width: 155px;
        max-width: 155px;
        transform: none;
    }

    .navContainer-pc {
        flex: 0 0 auto;
        margin-left: 8px;
    }

    .nav-inner {
        justify-content: flex-start;
        /* 菜单间距适配统一的内容宽度。 */
        gap: 16px;
        height: 90px;
        margin: 0;
        padding: 0;
    }

    .nav-item {
        padding: 6px 10px;
        font-size: 16px;
        white-space: nowrap;
    }

    #top_menu {
        position: static;
        align-items: center;
        flex: 0 0 auto;
        margin-left: auto;
    }

    .userinformation {
        gap: 8px;
        margin: 0;
    }

    #top_menu .trans-lang,
    #top_menu .user-avatar-position {
        margin-top: 0;
    }

    .user-name {
        max-width: 82px;
    }
}

/* Tablet and mobile: use the drawer navigation before labels begin to wrap. */
@media (max-width: 1400px) {
    #header {
        height: 72px;
        border-bottom: 1px solid #eef0f3;
    }

    #logo {
        z-index: 2;
        margin: 0 22px;
    }

    #logo img {
        width: 170px !important;
        max-width: 170px;
        top: 50%;
    }

    .navContainer-pc,
    #top_menu {
        display: none !important;
    }

    .mobile-language-button {
        position: absolute;
        top: 50%;
        right: 72px;
        z-index: 5;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 6px;
        min-width: 76px;
        height: 40px;
        padding: 0 10px;
        border: 1px solid #e1e5ea;
        border-radius: 9px;
        background: #fff;
        color: #344054;
        cursor: pointer;
        font-size: 13px;
        font-weight: 600;
        transform: translateY(-50%);
        transition: border-color .2s ease, background-color .2s ease;
    }

    .mobile-language-button:hover {
        border-color: #cdd3dc;
        background: #f7f8fa;
    }

    .menu-btn {
        position: absolute;
        top: 50%;
        right: 22px;
        z-index: 5;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 40px;
        height: 40px;
        padding: 0;
        border: 1px solid #e1e5ea;
        border-radius: 9px;
        background: #fff;
        color: #344054;
        transform: translateY(-50%);
        transition: background-color .2s ease, color .2s ease, border-color .2s ease;
    }

    .menu-btn:hover {
        border-color: #cdd3dc;
        background: #f7f8fa;
    }

    .menu-btn .el-icon {
        font-size: 22px;
    }

    .menu-btn.is-open {
        position: fixed;
        top: 14px;
        right: 14px;
        z-index: 1002;
        border-color: #d8e3ec;
        background: #fff;
        color: #53687c;
        box-shadow: 0 4px 14px rgb(52 77 103 / 12%);
        transform: none;
    }

    .navContainer {
        display: block;
        width: min(86vw, 340px);
        overflow: hidden;
        border-left: 1px solid #e0e8ef;
        box-shadow: -12px 0 32px rgb(47 72 96 / 14%);
    }

    .menu-panel {
        overflow-x: hidden;
        overflow-y: auto;
        overscroll-behavior: contain;
    }

    .menu-panel li::after {
        content: "\203A";
    }

    .mobile-user {
        padding-top: 42px;
    }

    .user-info {
        min-width: 0;
    }

    .user-top {
        padding-right: 44px;
    }

    .mobile-member-link {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 5px;
        min-height: 34px;
        margin-left: auto;
        padding: 0 10px;
        border: 1px solid #dce5ec;
        border-radius: 8px;
        background: rgba(247, 250, 252, .9);
        color: #607487;
        font-size: 13px;
        white-space: nowrap;
        cursor: pointer;
    }

    .mobile-member-link:hover,
    .mobile-member-link:active {
        border-color: #b9cad8;
        background: #eef4f8;
        color: #405d75;
    }

    .mobile-member-link .el-icon {
        color: #7b91a5;
        font-size: 15px;
    }
}

.top-banner {
    position: relative;
    background: linear-gradient(105deg, #334155 0%, #475569 100%);
    box-shadow: inset 0 -1px 0 rgb(255 255 255 / 10%);
}

.feedback-top-entry {
    position: absolute;
    top: 10px;
    right: 24px;
    z-index: 3;
}

.feedback-top-button {
    display: inline-flex;
    height: 38px;
    align-items: center;
    justify-content: center;
    gap: 7px;
    padding: 0 14px;
    border: 1px solid rgb(255 255 255 / 55%);
    border-radius: 8px;
    background: rgb(255 255 255 / 10%);
    box-shadow: 0 5px 16px rgb(15 23 42 / 20%);
    color: #fff;
    cursor: pointer;
    font-size: 13px;
    font-weight: 700;
    line-height: 1;
    white-space: nowrap;
    transition: background-color .2s, border-color .2s;
}

.feedback-top-button:hover,
.feedback-top-button:focus-visible {
    border-color: #fff;
    background: rgb(255 255 255 / 18%);
    outline: none;
}

.top-banner::before,
.top-banner::after {
    position: absolute;
    width: 240px;
    height: 80px;
    border-radius: 50%;
    background: rgb(255 255 255 / 6%);
    content: '';
    filter: blur(2px);
    pointer-events: none;
}

.top-banner::before {
    top: -52px;
    left: 12%;
}

.top-banner::after {
    right: 10%;
    bottom: -58px;
}

.top-banner-message {
    position: absolute;
    z-index: 1;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    line-height: 1.45;
    text-align: center;
}

.top-banner-message-content {
    display: inline-flex;
    max-width: calc(100% - 48px);
    min-height: 32px;
    padding: 5px 18px;
    border: 1px solid rgb(255 255 255 / 14%);
    border-radius: 999px;
    background: rgb(255 255 255 / 8%);
    box-shadow: 0 5px 18px rgb(15 23 42 / 16%);
    font-size: 14px;
    line-height: 20px;
    align-items: center;
    justify-content: center;
    gap: 8px;
    white-space: nowrap;
}

.top-banner-message-content::before {
    width: 5px;
    height: 5px;
    border-radius: 50%;
    background: rgb(255 255 255 / 72%);
    content: '';
    flex: 0 0 5px;
}

.top-banner-kicker {
    padding: 1px 6px;
    border: 1px solid rgb(255 255 255 / 22%);
    border-radius: 5px;
    background: rgb(255 255 255 / 20%);
    font-size: 10px;
    font-weight: 800;
    line-height: 16px;
    letter-spacing: .7px;
}

.top-banner-highlight {
    color: #ffe66b;
    font-size: 14px;
    font-weight: 900;
    line-height: 20px;
    text-shadow: 0 1px 5px rgb(15 23 42 / 35%);
}

.top-banner-message-content.is-solution {
    min-height: 28px;
    padding: 4px 14px;
    border-color: rgb(255 255 255 / 8%);
    background: rgb(255 255 255 / 4%);
    box-shadow: none;
    color: rgb(255 255 255 / 78%);
    font-size: 14px;
    font-weight: 400;
    gap: 4px;
}

.top-banner-message-content.is-solution::before {
    width: 4px;
    height: 4px;
    margin-right: 3px;
    background: rgb(255 255 255 / 42%);
    flex-basis: 4px;
}

.top-banner-message-content.is-solution .top-banner-highlight {
    color: rgb(255 255 255 / 88%);
    font-size: inherit;
    font-weight: 600;
    line-height: inherit;
    text-shadow: none;
}

.top-banner-message-enter-active,
.top-banner-message-leave-active {
    transition: opacity .65s ease, transform .65s ease;
}

.top-banner-message-enter-from {
    opacity: 0;
    transform: translateY(4px);
}

.top-banner-message-leave-to {
    opacity: 0;
    transform: translateY(-4px);
}

@media (prefers-reduced-motion: reduce) {

    .top-banner-message-enter-active,
    .top-banner-message-leave-active {
        transition-duration: .01ms;
    }
}

@media (max-width: 768px) {
    .mobile-user {
        padding-top: 32px;
    }

    .user-top {
        padding-right: 42px;
    }

    .mobile-member-link {
        min-height: 30px;
        padding: 0 8px;
        font-size: 12px;
    }

    .top-banner {
        display: none;
    }

    #header {
        height: 64px;
    }

    #logo {
        margin: 0 14px;
    }

    #logo img {
        width: 150px !important;
        max-width: 150px;
    }

    .menu-btn {
        right: 14px;
        width: 38px;
        height: 38px;
    }

    .mobile-language-button {
        right: 62px;
        min-width: 72px;
        height: 38px;
        padding: 0 8px;
    }
}

@media (max-width: 380px) {
    #logo img {
        width: 136px !important;
        max-width: 136px;
    }

    .mobile-language-button {
        min-width: 40px;
        padding: 0;
    }

    .mobile-language-button span {
        display: none;
    }
}

/* ===== 面包屑行 ===== */
.header-crumb {
    border-top: 1px solid #f0f1f3;
    background: #fff;
}

.header-crumb-inner {
    display: flex;
    align-items: center;
    gap: 8px;
    height: 40px;
    margin: 0 auto;
    padding: 0 24px;
    font-size: 13px;
}

.header-crumb-home {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    color: #4b5563;
    text-decoration: none;
}

.header-crumb-home:hover {
    color: #e94d4d;
}

.header-crumb-sep {
    color: #b0b8c1;
}

.header-crumb-slot {
    min-width: 0;
    overflow: hidden;
}

@media (min-width: 1401px) {
    .header-crumb-inner {
        max-width: var(--app-content-width);
        padding: 0 12px;
    }
}

@media (max-width: 1400px) {
    .header-crumb-inner {
        height: 38px;
        padding: 0 16px;
        font-size: 12px;
    }
}
</style>

<style>
/* 面包屑内容由 PageTitle teleport 进来，不受 header 的 scoped 样式影响 */
.header-crumb:not(:has(.page-title-path)) {
    display: none;
}

.header-crumb .header-crumb-slot .page-title-item {
    color: #6b7280;
    font-size: 13px !important;
    font-weight: 400;
}

.header-crumb .header-crumb-slot .page-title-item.is-current,
.header-crumb .header-crumb-slot .page-title-switch {
    color: #c8343a;
    font-size: 13px !important;
    font-weight: 600;
}

.header-crumb .header-crumb-slot .page-title-separator {
    padding: 0 8px;
    color: #b0b8c1;
    font-size: 13px;
}
</style>
